import React, { useState, useEffect } from 'react';
import './Header.css';
import './Modal.css'; // We will create this file

const CallModal = ({ onClose }) => (
  <div className="modal-overlay" onClick={onClose}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <h2>Contact Us</h2>
      <p>How would you like to get in touch?</p>
      <div className="modal-actions">
        <a href="tel:+13107217974" className="btn btn-primary">
          Call Us
        </a>
        <a href="sms:+13107217974" className="btn btn-secondary">
          Text Us
        </a>
      </div>
      <button onClick={onClose} className="modal-close-btn">✕</button>
    </div>
  </div>
);

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('home');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isMobile = () => window.innerWidth <= 768;

  const handleCallClick = (e) => {
    e.preventDefault();
    if (isMobile()) {
      window.location.href = "tel:+13107217974";
    } else {
      setIsModalOpen(true);
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'services', 'portfolio', 'testimonials', 'about', 'contact'];
      const scrollPosition = window.scrollY + 150;

      for (const sectionId of sections) {
        const section = document.getElementById(sectionId);
        if (section && section.offsetTop <= scrollPosition && section.offsetTop + section.offsetHeight > scrollPosition) {
          setActiveLink(sectionId);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header className="header">
        <a href="#home" className="logo" onClick={handleLinkClick}>HandyFixWise</a>
        <div className="menu-icon" onClick={toggleMenu}>
          {isOpen ? '✕' : '☰'}
        </div>
        <nav className={`main-nav ${isOpen ? 'open' : ''}`}>
          <a href="#home" className={activeLink === 'home' ? 'active' : ''} onClick={handleLinkClick}>Home</a>
          <a href="#services" className={activeLink === 'services' ? 'active' : ''} onClick={handleLinkClick}>Services</a>
          <a href="#portfolio" className={activeLink === 'portfolio' ? 'active' : ''} onClick={handleLinkClick}>Portfolio</a>
          <a href="#about" className={activeLink === 'about' ? 'active' : ''} onClick={handleLinkClick}>About</a>
          <a href="#contact" className={activeLink === 'contact' ? 'active' : ''} onClick={handleLinkClick}>Contact</a>
          <a href="#contact" className="btn btn-orange mobile-cta" onClick={handleLinkClick}>Get a Free Quote</a>
        </nav>
        <div className="desktop-cta-group">
          <button onClick={handleCallClick} className="btn btn-secondary" title="Call Handy FixWise" aria-label="Call Handy FixWise">Call Us</button>
          <a href="#contact" className="btn btn-orange">Get a Free Quote</a>
        </div>
      </header>
      {isModalOpen && <CallModal onClose={() => setIsModalOpen(false)} />}
    </>
  );
};

export default Header;
